// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const translations = {
  login: 'Логин',
  lastName: 'Фамилия',
  firstName: 'Имя',
  middleName: 'Отчество',
  phone: 'Телефон',
  email: 'E-mail',
  conditionalBalance: 'Показывать условные остатки',
  contentLineHeight: 'Межстрочный интервал описания товара',
  enabled: 'Активен',
  selectedByDefault: 'Выбран по умолчанию',
  selected: 'Выбрано',
  totalProducts: 'Всего товаров',
  baseGroup: 'Базовая группа',
  showPrice: 'Показывать цены',
  makeEnabled: 'Активировать',
  changeCategory: 'Категория',
  changeBrand: 'Бренд',
  changeManufacturer: 'Производитель',
  changeCountry: 'Страна',
  makeDisable: 'Деактивировать',
  createdAt: 'Дата создания',
  updatedAt: 'Дата обновления',
  createdAtShort: 'Создан',
  updatedAtShort: 'Обновлен',
  action: 'Действия',
  confirmDelete: 'Вы действительно хотите удалить',
  confirmRelpaceProductTemplate: 'Вы действительно хотите заменить шаблон товара? Все текущие характеристики будут утеряны',
  confirmHardProductTemplateDelete: 'Вы действительно хотите удалить выбранный шаблон? Все товары шаблона потеряют описания',
  record: 'запись',
  newPiece: 'новость',
  roles: 'Роли',
  password: 'Пароль',
  passwordValidationMsg: 'Пароль слишком короткий',
  emailValidationMsg: 'Некорректный E-mail',
  urlValidationMsg: 'Некорректный URL',
  requiredValidationMsg: 'Это поле обязательно для заполнения',
  requiredAll: 'Заполните все поля',
  unsavedChanges: 'Сохраните внесенные изменения',
  promotions: 'Акции',
  salesPoint: 'Где купить',
  syncUid: 'UID',
  created: 'Запись создана',
  updated: 'Запись обновлена',
  successfully: 'Успешно',
  errorTitle: 'Ошибка',
  administrators: 'Администраторы',
  code: 'Код',
  name: 'Название',
  header: 'Название',
  deliveryDays: 'Доставка, дней',
  description: 'Описание',
  adminRoles: 'Роли администраторов',
  editorWorkReport: 'Отчет работы редакторов',
  customersRoles: 'Роли пользователей',
  content: 'Контент',
  news: 'Новости',
  pages: 'Текстовые страницы',
  deliveryMethod: 'Способы доставки',
  paymentMethod: 'Способы оплаты',
  orderProvider: 'Источники заказов',
  currency: 'Валюта',
  sign: 'Символ',
  customer: 'Покупатель',
  date: 'Дата',
  picture: 'Фотография',
  chooseFile: 'Выбрать файл',
  chooseFile2: 'Кликните или перетащите сюда файл',
  roleRule: 'Код роли должен начинаться с ROLE_ и быть в верхнем регистре',
  uncheckedError: 'Возникла непредвиденная ошибка. Попробуйте позднее',
  templateDefinitionError: 'Необходимо выбрать шаблоны для маппинга',
  templateFeatureMapping: 'Маппинг характеристик',
  templateFeatureValueMapping: 'Маппинг значений характеристик',
  photo: 'Фото',
  catalog: 'Каталог',
  countVersion: 'Вложений',
  supplier: 'Поставщик',
  suppliers: 'Поставщики',
  supplierPlaceholder: 'Выберите поставщика',
  warehouses: 'Склады',
  featureGroups: 'Группы характеристик',
  address: 'Адрес',
  facebook_link: 'Facebook',
  mail_email: 'Главный email',
  order_email: 'Email для заказа',
  site_link: 'Ссылка на сайт',
  site_name: 'Название сайта',
  twitter_link: 'Twitter',
  instagram_link: 'Instagram',
  vk_link: 'ВКонтакте',
  youtube_link: 'Youtube',
  video: 'Видео',
  settings: 'Настройки',
  icon: 'Иконка',
  iconColor: 'Цвет иконка',
  url: 'URL адрес',
  htKeywords: 'Ключевые слова',
  htHead: 'SEO-заголовок',
  htDesc: 'SEO-описание',
  parent: 'Родительская категория',
  root: 'Корень',
  position: 'Позиция',
  units: 'Единицы измерения',
  channels: 'Каналы',
  feature_types: 'Типы характеристик',
  feature_unions: 'Типы объединения',
  features: 'Характеристики',
  small_header: 'Краткое наименование',
  feature_group: 'Группа характеристики',
  marketplace: 'Маркетплейс',
  feature_type: 'Тип характеристики',
  channel: 'Канал',
  choose: 'Выбрать',
  isFilter: 'Использовать в фильтре',
  required: 'Обязательный',
  filterRestriction: 'тип не может учавствовать в фильтрации',
  value: 'Значение',
  values: 'Значения',
  addToTemplateFeatures: 'Добавить новые значения во все шаблоны',
  valuesLabelWithInfo: 'Значения (каждое с новой строки)',
  addValue: 'Добавление значения',
  addValues: 'Добавление значений',
  addTemplateFeatureGroup: 'Добавление группы',
  addTemplateFeature: 'Добавление характеристики',
  color: 'Цвет',
  manufacturer: 'Производитель',
  manufacturerCode: 'Код производителя',
  manufacturerSeries: 'Серия',
  manufacturerPlaceholder: 'Выберите производителя',
  manufacturers: 'Производители',
  brand: 'Бренд',
  brandPlaceholder: 'Выберите бренд',
  brands: 'Бренды',
  series: 'Серии',
  wms_groups: 'Группы складов',
  regions: 'Регионы',
  company: 'Компания',
  manager: 'Менеджер',
  managerPlaceholder: 'Выберите менеджера',
  parentCustomer: 'Родитель',
  customerRolePlaceholderReq: 'Если указан родиль - роль субаккаунт',
  fact_address: 'Фактический адрес',
  legal_address: 'Юридический адрес',
  account: 'Счет',
  correspondent_account: 'Корреспондентский счет',
  correspondent_bank: 'Корреспондентский банк',
  correspondent_swift: 'Корреспондентский swift',
  bank: 'Банк',
  beneficiary: 'Бенефициары',
  swift: 'swift',
  bik: 'БИК',
  inn: 'ИНН',
  ogrn: 'ОГРН',
  counterParty: 'Контрагент',
  counterPartys: 'Контрагенты',
  customers: 'Клиенты',
  contracts: 'Контракты',
  contract: 'Контракт',
  reserve: 'Резерв',
  limit_sum: 'Лимит (сумма)',
  limit_day: 'Лимит (дни)',
  typePrice: 'Тип цены',
  products: 'Товары',
  productChanges: 'Изменения товара',
  totalProductChangesCount: 'Количество',
  changedAt: 'Дата изменения',
  changedBy: 'Логин',
  productChangeSupplier: 'Тип изменения',
  changedProductFieldLabels: {
    parentId: 'Родительский товар',
    catalogId: 'Каталог',
    supplierId: 'Поставщик',
    countryId: 'Страна',
    manufacturerId: 'Производитель',
    brandId: 'Бренд',
    manufacturerSeriesId: 'Серия',
    featureUnionConditionId: 'Тип объединения',
    productGroupId: 'Группа',
    productClassId: 'Класс',
    productStatusId: 'Статус',
    unitId: 'Ед. изм.',
    templateId: 'Шаблон',
    taxId: 'Ставка налога',
    productTags: 'Теги',
    productSystemTags: 'Системные маркеры',
    catalogs: 'Дополнительные категории',
    terms: 'Синонимы',
    relatedGoods: 'Сопутствующие',
  },
  productCode: 'Типы кодов',
  productCodeField: 'Код товара',
  document: 'Документ',
  commercialCode: 'Коммерческий код',
  productGroups: 'Группы товаров',
  deleted: 'удален',
  warehouseGroup: 'Группа складов',
  region: 'Регион',
  customerGroup: 'Группа пользователей',
  segment: 'Сегмент',
  segmentPlaceholder: 'Выберите сегмент',
  segments: 'Сегменты',
  productStatusList: 'Статусы товара',
  countries: 'Страны',
  systemTags: 'Системные маркеры',
  systemTagsShort: 'Маркеры',
  tag: 'Тег',
  tags: 'Теги',
  barCode: 'Штрихкод',
  articul: 'Артикул',
  basePrice: 'Базовая цена',
  unit: 'Ед. изм.',
  country: 'Страна',
  status: 'Статус',
  weight: 'Вес',
  width: 'Ширина',
  height: 'Высота',
  length: 'Длина',
  depth: 'Глубина',
  featureUnionCondition: 'Тип объединения',
  group: 'Группа',
  relationExists: 'Связь уже существует',
  warning: 'Предупреждение',
  selectCatalogs: 'Выберите категории',
  selectOneCatalog: 'Выберите каталог',
  relationship: 'связь',
  customersMenu: 'Пользовательское меню',
  administratorsMenu: 'Административное меню',
  image: 'изображение',
  documents: 'Документы',
  collections: 'Коллекции',
  files: 'Файлы',
  file: 'Файл',
  size: 'Размер',
  mime: 'Тип',
  notifications: 'Оповещения',
  logs: 'Логи',
  cronLogs: 'Крон-задачи',
  syncCron: 'Cron-выражение',
  endpoint: 'Конечная точка',
  ip: 'IP адрес',
  method: 'Метод',
  parent_product: 'Родительский товар',
  linearChart: 'Линейный график',
  simpleTable: 'Таблица',
  pivotTable: 'Сводная таблица',
  period: 'Период',
  countNumber: 'Количество',
  today: 'Сегодня',
  week: 'Неделя',
  month: 'Месяц',
  year: 'Год',
  mon: 'Пн',
  tue: 'Вт',
  wed: 'Ср',
  trd: 'Чт',
  fri: 'Пн',
  sun: 'Сб',
  sat: 'Вс',
  jan: 'Янв',
  feb: 'Фев',
  mar: 'Мар',
  apr: 'Апр',
  may: 'Май',
  jun: 'Июн',
  jul: 'Июл',
  aug: 'Авг',
  sep: 'Сен',
  okt: 'Окт',
  nov: 'Ноя',
  dec: 'Дек',
  eventTypes: 'Типы событий',
  eventType: 'Тип события',
  eventTransport: 'Транспорт событий',
  events: 'События',
  destination: 'Адресат',
  link: 'Ссылка',
  yes: 'Да',
  no: 'Нет',
  placeholderSelect: 'Выберите',
  searchProducts: 'Поиск товаров',
  discountMatrix: 'Матрица скидок',
  contractBrandDiscount: 'Матрица скидок на контракты',
  discount: 'Скидка',
  edit: 'Редактирование',
  add: 'Добавить',
  forAll: 'Применить для всей выборки',
  forSelected: 'Применить для выбранных',
  operations: 'Операции',
  selectOperations: 'Выберите операцию',
  batchUpdateError: 'Выберите товар в таблице или поставьте галочку "Для всех"',
  batchUpdateError2: 'Выберите галочку "Применить для выбранных" или "Применить для всей выборки"',
  productCatalogUpdateError: 'Выберите вложенную подкатегорию товаров',
  successfullyCreate: 'Успешно создано',
  batchCreate: 'Вы уверены, что хотите начать обновление?',
  prices: 'Цены',
  price: 'Цена',
  remains: 'Остатки',
  organization: 'Организация',
  batchOperations: 'Массовые операции',
  stepName: 'Название шага',
  jobExecutionId: 'ID Операции',
  jobExecuted: 'Операция запущена. Статус выполнения можно увидеть в <a href="/cabinet/batch" target="_blank">разделе массовых операций</a>',
  exitMessage: 'Сообщение на выходе',
  commitCount: 'Количество коммитов',
  readCount: 'Количество чтений',
  writeCount: 'Количество записей',
  createTime: 'Дата создания',
  startTime: 'Дата старта',
  endTime: 'Дата завершения',
  exitCode: 'Код завершения',
  stepStatus: 'Статус шага',
  confirmStop: 'Вы действительно хотите остановить',
  process: 'Процесс',
  eventTemplates: 'Шаблоны событий',
  target: 'Назначение',
  users: 'Пользователи',
  system: 'Система',
  subject: 'Тема сообщения',
  lastAuth: 'Последняя авторизация',
  orderCount: 'Количество заказов',
  orderSum: 'Сумма заказов',
  banner: 'Баннеры',
  equipmentCatalog: 'Каталог оборудования',
  ranging: 'Ранжирование',
  stockSearch: 'Наличие на складе',
  recommendedSearch: 'Рекомендованный товар',
  newArrival: 'Новинка',
  hasPriceSearch: 'Наличие цены',
  hasImageSearch: 'Наличие изображения',
  mailingSubject: 'Темы рассылок',
  subscribers: 'Подписчики',
  registrationProductGroups: 'Товарные группы выбираемые при регистрации',
  registrationRequests: 'Заявки на регистрацию',
  companyType: 'Тип компании',
  activityType: 'Вид деятельности',
  city: 'Город',
  job: 'Должность',
  firstname: 'Имя',
  lastname: 'Фамилия',
  patronymic: 'Отчество',
  subscribe: 'Подписка',
  userAgreement: 'Пользовательское соглашение',
  politicsAgreement: 'Политика безопасности',
  searchLog: 'Лог поиска',
  query: 'Запрос',
  countProduct: 'Количество товаров',
  countNumberSearch: 'Кол-во идентичных запросов за всё время',
  userId: 'ID пользователя',
  anons: 'Анонс',
  fullHeader: 'Полное название',
  manufacturerSiteLink: 'Ссылка на сайт производителя',
  multiplicitySupplier: 'Кратность заказа поставщика',
  multiplicityOrder: 'Кратность продажи',
  minOrderQuantity: 'Минимальный заказ',
  smsProviders: 'SMS провайдеры',
  tokenOrPassword: 'Токен или пароль',
  optionField: 'Опциональное поле',
  requestsAndSynonyms: 'Запросы и синонимы',
  catalogTreeSynonymUpdate: 'Обновить синонимы во всех дочерних разделах',
  codeField: 'codeField',
  codeFieldNgram: 'codeFieldNgram',
  codesManufacturer: 'codesManufacturer',
  codesManufacturerNgram: 'codesManufacturerNgram',
  manufacturerHeader: 'manufacturerHeader',
  synonyms: 'Синонимы',
  headerRanging: 'header',
  headerNgram: 'headerNgram',
  headerKeyword: 'headerKeyword',
  synonymsCatalog: 'Синонимы каталога',
  synonymsCatalogNgram: 'synonymsCatalogNgram',
  synonymsManufacturer: 'Синонимы бренда',
  synonymsManufacturerNgram: 'synonymsManufacturerNgram',
  className: 'className',
  classSynonym: 'classSynonym',
  headerAuto: 'headerAuto',
  delimeterCodeField: 'delimeterCodeField',
  delimeterCodeFieldKeywords: 'delimeterCodeFieldKeywords',
  delimeterHeader: 'delimeterHeader',
  delimeterHeaderNgram: 'delimeterHeaderNgram',
  delimeterHeaderKeyword: 'delimeterHeaderKeyword',
  delimeterHeaderWorldDelimeter: 'delimeterHeaderWorldDelimeter',
  delimeterCodesManufacturer: 'delimeterCodesManufacturer',
  delimeterCodesManufacturerKeyword: 'delimeterCodesManufacturerKeyword',
  delimeterManufacturerHeader: 'delimeterManufacturerHeader',
  delimeterSynonyms: 'delimeterSynonyms',
  delimeterSynonymsWorldDelimeter: 'delimeterSynonymsWorldDelimeter',
  delimeterSynonymsNgram: 'delimeterSynonymsNgram',
  delimeterSynonymsCatalog: 'delimeterSynonymsCatalog',
  delimeterSynonymsCatalogNgram: 'delimeterSynonymsCatalogNgram',
  delimeterSynonymsManufacturer: 'delimeterSynonymsManufacturer',
  delimeterSynonymsManufacturerNgram: 'delimeterSynonymsManufacturerNgram',
  delimeterClassName: 'delimeterClassName',
  delimeterClassSynonym: 'delimeterClassSynonym',
  delimeterHeaderAuto: 'delimeterHeaderAuto',
  featureValueRestriction: 'Не корректное значение',
  searchSynonyms: 'Синонимы',
  synonymsColumn: 'Синонимы',
  operationModeColumn: 'Режим добавления',
  includeTokensColumn: 'Включает токены',
  excludeTokensColumn: 'Исключает токены',
  productProcessed: 'Количество товаров',
  operationStatus: 'Статус',
  finishedAt: 'Окончание процесса',
  operationModes: {
    add: 'Добавление',
    replace: 'Замена',
    exclude: 'Исключение',
  },
  operationStatuses: {
    pending: 'Выполняется',
    finished: 'Выполнено',
    failed: 'Ошибка',
  },
  packingTypes: 'Типы тары',
  packingType: 'Тип тары',
  packing: 'Тара',
  volume: 'Объем',
  grossWeight: 'Вес брутто',
  area: 'Площадь',
  goldFeature: 'Золотая характеристика',
  isIntFeature: 'Целое число',
  intNumberPlaceholder: 'Целое число: 15',
  floatNumberPlaceholder: 'Число: 15 или 15.5',
  pickupAddresses: 'Адреса самовывоза',
  analogs: 'Аналоги',
  analog: 'Аналог',
  analogName: 'Название аналога',
  analogTypes: 'Тип аналога',
  connectionType: 'Тип связи',
  product: 'Товар',
  productName: 'Название товара',
  relateds: 'Сопутствующие товары',
  related: 'Сопутствующий товар',
  packingPlaceholder: 'Выберите тару',
  warehouse: 'Склад',
  warehousePlaceholder: 'Выберите склад',
  stock: 'Остаток',
  stockPlaceholder: 'Введите остаток',
  freeStock: 'Свободный остаток',
  freeStockPlaceholder: 'Введите свободный остаток',
  calcAnalog: 'Расчет аналогов',
  orderNumber: 'Номер заказа',
  orderNumber1C: 'Номер заказа 1С',
  orderStatus: 'Статус заказа',
  accountNumber: 'Номер счета',
  totalCost: 'Общая сумма',
  orders: 'Заказы',
  amount: 'Количество',
  sum: 'Сумма',
  carts: 'Корзины пользователей',
  cart: 'Корзина',
  user: 'Пользователь',
  orderSummary: 'Общая сумма заказов',
  userBuyers: 'Количество покупателей, сделавших заказы',
  userNoBuyers: 'Количество покупателей, без покупок',
  orderAvg: 'Средний чек',
  ecommerceInfo: 'Коммерческая информация',
  orderCountAvg: 'Среднее число заказов в день',
  targetUrl: 'Ссылка',
  baseUnit: 'Базовая единица',
  templateGroup: 'Группы шаблонов',
  templates: 'Список шаблонов',
  pimTemplates: 'Список шаблонов PIM',
  templateHeader: 'Шаблон',
  deleteTemplateFeatureGroup: 'группу характеристик',
  deleteTemplateFeature: 'характеристику',
  featureCount: 'Кол-во характеристик',
  keyFeatureCount: 'Кол-во ключевых характеристик',
  productCount: 'Кол-во товаров',
  comment: 'Комментарий',
  goToContract: 'Перейти к контракту',
  goToCustomer: 'Перейти к клиенту',
  templateGroupHeader: 'Группа шаблонов',
  templateRelatedEntity: 'Тип номенклатуры',
  templateProductRelatedEntity: 'Товар',
  templateServiceRelatedEntity: 'Услуга',
  changeAdditionalCategories: 'Дополнительные категории',
  templateId: 'ID Шаблона',
  priceType: 'Тип цены',
  changeAddTags: 'Теги',
  deleteTags: 'Удалить все теги',
  delete: 'Удалить',
  unitType: 'Тип единицы',
  subUnit: 'Зависимая единица',
  selectUnitType: 'Выберите тип единицы измерения',
  tagType: 'Тип тега',
  tagInner: 'Внутренний тег',
  tagOuter: 'Внешний тег',
  selectTag: 'Выберите тег',
  changeProductParams: 'Параметры товара',
  selectProductParams: 'Выберите параметр',
  productGroup: 'Группa товаров',
  changeProductFeatures: 'Характеристики товара',
  applyTemplate: 'Назначить шаблон',
  replaceTemplate: 'Заменить шаблон',
  templateGroupDuplicateError: 'Название группы "__GROUP_HEADER__" не уникально.',
  templateFeatureDuplicateError: 'Название характеристики "__FEATURE_HEADER__" не уникально в группе "__GROUP_HEADER__".',
  default: 'По умолчанию',
  serialNumber: 'Порядковый номер',
  spySessionDuration: 'Длительность сессии',
  spyQntCart: 'В корзину',
  spyQntOrder: 'Кол-во заказов',
  spySessionCount: 'Кол-во сеансов',
  spyQntSearch: 'Поиск товара',
  noResults: 'Ничего не найдено',
  profile: 'Профиль',
  telegram_link: 'Telegram',
  question: 'Вопрос',
  answer: 'Ответ',
  faqGroup: 'Группа Вопрос-Ответ',
  noEntry: 'Нет записей',
  faq: 'Вопросы и ответы',
  confirmImpersonate: 'Войти на портал под пользователем',
  confirmImpersonatePart: 'Вы будете перенаправлены в личный кабинет пользователя на портале',
  activePrice: 'Включить цены',
  deactivePrice: 'Выключить цены',
  oldFeatureValue: 'Старое значение',
  newFeatureValue: 'Новое значение',
  importType: 'Тип импорта',
  importMode: 'Режим импорта',
  uploadProducts: 'Загрузка товаров из файла',
  positions: 'Позиций',
  templateReplacement: 'Новый шаблон',
  changeProductTemplate: 'Смена шаблона',
  batchReplaceFeatureValueCountError: 'Выберите только одно значение для замены',
  chosenSameValuesForReplacementError: 'Выберите разные значения для замены',
  catalogRemoved: 'Каталог успешно удален',
  changeModesLabel: 'Тип изменения',
  changeModes: {
    add: 'Добавление',
    replace: 'Замена',
    exclude: 'Исключение',
  },
  updateCode: 'Идентификационное поле',
  suppliersTemplates: 'Список шаблонов импорта',
  marketplacePlaceholder: 'Выберите маркетплейс',
  marketplaceCredential: 'Подключение',
  marketplaceCredentialTitle: ' Список подключений к маркетплейсам',
  marketplaceCatalog: 'Выберите категорию маркетплейса',
  damRelatedClass: 'Связаный класс для DAM',
  startDate: 'Начало использования',
  endDate: 'Конец использования',
  existsProductWithSeveralValuesError: 'Невозможно изменить настройки характеристики. Существуют товары с несколькими значениями для данной характеристики',
  useCatalogFromFile: 'Использовать каталог из файла',
  columnAlreadyChosen: 'Колонка уже выбрана',
  priceTypeCurrencyAlreadyChosen: 'Сочетание типа цены и валюты уже выбрана',
  warehouseAlreadyChosen: 'Склад уже выбран',
  tax: 'Ставка налога',
  validatorsTitle: 'Валидаторы',
  spaceSymbol: 'Пробел',
  underscoreSymbol: 'Нижнее подчеркивание',
  dashSymbol: 'Тире',
  pointSymbol: 'Точка',
  commaSymbol: 'Запятая',
  cyrillicAlphabet: 'Кирилица',
  latinAlphabet: 'Латиница',
  characterUpperCase: 'Большие буквы',
  characterLowerCase: 'Маленькие буквы',
  confirmRemovingValidator: 'Выбранный валидатор не совместим с новыми настройками. Изменение настройки повлечет удаление выбранного валидатора. Вы действительно хотите продолжить?',
  supplierImportModes: {
    createUpdate: 'Создание и обновление',
    create: 'Создание',
    update: 'Обновление',
  },
  assignTemplate: 'Назначить шаблон',
  removeTemplateFeatureWithExistsValuesError: 'Невозможно удалить. Значения используются в Карточках товаров.',
  removeTemplateFeatureValueError: 'Невозможно удалить. Удалите значение из карточек товара.',
  notHeaderUniqueError: 'Название должно быть уникальным',
  marketplaceTemplates: 'Список шаблонов маркетплейсов',
  unitGroups: 'Группы единиц измерения',
  configFeatureValidator: 'Настроить валидаторы',
  configFeatureUnit: 'Настроить ед. измерения',
  isApi: 'Интеграция по API',
  isFile: 'Интеграция через файл XLSX',
  allProductOfTemplateAdd: 'Добавить все активные товары шаблона',
  folders: 'Папки',
  updateProductCode: 'Код товара',
  catalogAlreadyChosen: 'Данная категория уже назначена',
  absenceProductIdentificationField: 'В маппинге не задано идентификационное поле',
  supplierImport: 'Импорт данных',
  importTaskCreated: 'Задание создано',
  chooseImportFile: 'Выберите файл .xlsx',
  fileAddedToProcess: 'Файл добавлен в обработку',
  changedColumnInImportFile: 'Нашли расхождения в составе колонок. Пожалуйста, скорректируйте маппинг.',
  dam: {
    damItemVersionHistoryModal: 'История версий DAM элемента',
    approved: 'Одобрен',
    toApproved: 'Одобрить',
    notApproved: 'Снять одобрение',
    read: 'Чтение',
    write: 'Запись',
    administration: 'Администрирование',
    create: 'Создание',
    delete: 'Удаление',
    rename: 'Переименовать',
  },
  copiedToClipboard: 'Скопировано в буфер',
  owner: 'Владелец',
  damChangeAcl: 'Изменить разрешения',
  selectChangeAclModeSelected: 'Выберите разрешения, которые хотети изменить',
  damTransformationError: 'Ошибка трансформации файла',
  persons: 'Персоны',
  person: 'Персона',
  latitude: 'Широта',
  longitude: 'Долгота',
  workingHours: 'Режим работы',
  typeAddress: 'Введите адрес',
  exportType: 'Тип экспорта',
  exclusionMatrix: 'Матрица Исключения',
  promoCode: 'Промокод',
  promoType: 'Тип скидки',
  bindNewProduct: 'Добавление нового товара',
  hasDeleted: 'Запись удалена',
  usePromoCodes: 'Использовать промо-коды',
  TemplateGroupRoles: 'Управление ролевым доступом',
  dam_read: 'Чтение',
  dam_write: 'Запись',
  dam_administration: 'Администрирование',
  dam_create: 'Создание',
  dam_delete: 'Удаление',
  fromTo: 'От - До',
  contacts: 'Контакты',
  version: 'версия',
  versions: 'версии',
  versionsAll: 'версий',
  textValue: 'Текстовое значение',
  unitItems: 'Объединить элементы',
  uploaded: 'Загружен',
  uploaded1: 'Загружено',
  alreadyUpload: 'Данный файл уже загружен ранее',
  initiator: 'Инициатор',
  oldValue: 'Старое значение',
  newValue: 'Новое значение',
  operationUuid: 'UUID операции',
  role: 'Роль',
  deliveryZone: 'Зона доставки',
  deliveryZones: 'Зоны доставки',
  deliveryCompanies: 'Транспортные компании',
  deliveryCompany: 'Транспортная компания',
  deliveryAddresses: 'Адреса доставки',
  deliveryPickupPoints: 'Точки самовывоза',
  deliveryPickupPoint: 'Точка самовывоза',
  smallStock: 'Мало до',
  enoughStock: 'Достаточно до'
};
